import React, { useEffect } from 'react';
import { useParams, useHistory } from 'react-router-dom';
import { Spinner } from 'react-bootstrap';
import { toast } from 'react-toastify';

import styles from './index.module.scss';

import { useSearchQuery } from 'hooks/location';
import AxiosClient from 'configurations/api-client';
import { buildApiGiftCardCancel } from 'constants/api-paths';
import { getErrorMessage } from 'utils/message';

const GiftCardCancelPage = () => {
  const { siteSlug } = useParams();
  const history = useHistory();
  const query = useSearchQuery();

  const redirectTo = query.get('redirectTo');
  const redemptionCode = query.get('redemptionCode');

  useEffect(() => {
    AxiosClient.get(buildApiGiftCardCancel(siteSlug, redemptionCode))
      .then(() => {
        toast.success('Gift card purchase canceled');
        history.replace(redirectTo);
      })
      .catch((error) => {
        toast.error(getErrorMessage(error));
        history.replace(redirectTo);
      });
  }, [history, redemptionCode, redirectTo, siteSlug]);

  return (
    <div className='container profile'>
      <div className={styles.wrapper}>
        <div className='text-center'>
          <h3 className='mb-4'>Please wait a second.</h3>
          <Spinner animation='border' role='status' />
        </div>
      </div>
    </div>
  );
};

export default GiftCardCancelPage;
